/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CdsSoggetto } from "./CdsSoggetto";
import * as t from "io-ts";

// required attributes
const CdsSoggettoListR = t.interface({
  subjects: t.readonlyArray(CdsSoggetto, "array of CdsSoggetto")
});

// optional attributes
const CdsSoggettoListO = t.partial({});

export const CdsSoggettoList = t.intersection(
  [CdsSoggettoListR, CdsSoggettoListO],
  "CdsSoggettoList"
);

export type CdsSoggettoList = t.TypeOf<typeof CdsSoggettoList>;
